export default {
  tips: {
    no_options: "Варианты не найдены",
    search_by_name: "Искать по названию",
    required: "Это поле обязательно для заполнения",
    invalid_email_address: "Неверный адрес электронной почты",
    required_field: "является обязательным полем",

    mobile_number:
      "Номер мобильного телефона с кодом страны должен содержать от 8 до 23 цифр",
    alphabets: "Допустимы только буквы и цифры",
    numerics_and_hyphen: "Допустимы только буквы, цифры и дефис",
    numerics_and_space: "Допустимы только буквы, цифры и пробел",
    country_code_required: "Код страны обязателен",
    password_title:
      "Пароль должен содержать прописные и строчные буквы, цифры, специальные символы и иметь длину от 12 до 64 символов",
    numerics_and_underscore: "Допустимы только буквы, цифры и нижнее подчеркивание",
    dot_and_space: "Допустимы только буквы, цифры, пробел и точка",
    underscore_and_space:
      "Допустимы только буквы, цифры, пробел и нижнее подчеркивание",
    selected_delete_record: "Вы уверены, что хотите удалить выбранную запись?",
    occurred: "Произошла ошибка",
    no_record_found: "Записи не найдены",
    no_of_records_rer_page: "Количество записей на страницу",
    select_price_period: "Выберите период изменения цен",

    outlet_code: "Введите код торговой точки",
    country_name: "Введите название страны",
    state_name: "Введите название региона/области",
    city_name: "Введите название города",
    city_zone: "Введите район города",
    address: "Введите адрес",
    area_code: "Введите почтовый индекс",
    upload_size: "Размер изображения не может превышать 3 МБ",
    enter_number: "Введите число",
    search_retail_name: "Искать по названию розничного клиента",
    suggest_screen: "Рекомендуемое разрешение дисплея ценника",
    or_higher: "или выше",
    repeat_start: "Время начала повторения не может быть пустым",
    endTime_empty: "Время окончания повторения не может быть пустым",
    promotion_not:
      "Время окончания акции не может быть раньше времени начала акции",
    promotion_shall:
      "Время окончания акции не должно быть раньше времени начала",
    week_no_empty: "Неделя не может быть пустой",
    month_no: "Месяц не может быть пустым",
    date_no: "Дата не может быть пустой",
    year_no: "Год не может быть пустым",
    overlap: "Время акции и время повторения не должны пересекаться",
    repetition_time:
      "Время акции и время повторения не должны пересекаться",
    select_template: "Выберите шаблон",
    is_resend: "Отправить повторно на ценник?",
    select_at_least: "Выберите хотя бы один элемент",
  },

  common_tips: {
    country_code: "Введите код страны",
    mobile_number: "Введите номер мобильного телефона",
    first_name: "Введите имя",
    last_name: "Введите фамилию",
    address: "Введите адрес",
    country_name: "Введите название страны",
    state_name: "Введите название региона/области",
    city_name: "Введите название города",
    start_date: "Выберите дату начала",
    end_date: "Выберите дату окончания",
    operate_fail: "Операция не выполнена",
    select_status: "Выберите статус",
  },

  tips_retail_client: {
    name: "Введите название розничного клиента",
    code: "Введите код розничного клиента",
    email: "Введите электронную почту администратора клиента",
    devices: "Введите количество устройств",
    mobile_required: "Номер мобильного телефона обязателен",

    send_activation: "Вы уверены, что хотите отправить письмо активации?",
    activation_success: "Письмо активации успешно отправлено",
    created_success: "Клиент успешно создан",
    updated_success: "Данные клиента успешно обновлены",
    deleted_success: "Клиент успешно удален",
    user_exist: "Пользователь уже существует",
    given_name: "Клиент с таким названием уже существует",
    given_code: "Клиент с таким кодом уже существует",

    subscription_start_date_invalid:
      "Неверная дата, выберите дату начала подписки",
    subscription_expire_date_invalid:
      "Неверная дата, выберите дату окончания подписки",
  },

  tips_Template: {
    name: "Введите название шаблона",
    characters: "Название должно содержать менее 51 символа",
    screen_resolution: "Неверное разрешение дисплея ценника",
    success: "Шаблон успешно создан",
    updated: "Шаблон успешно обновлен",
    deleted: "Шаблон успешно удален",
    not_deleted: "Стандартный шаблон нельзя удалить",
    sure_delete: "Вы уверены, что хотите удалить выбранные элементы?",
    can_not_deleted: "Шаблон привязан к ценникам, удаление невозможно",
    template_exist: "Шаблон с таким названием уже существует",
  },

  tips_editor: {
    qrCodeColor: "цвет",
    is_exists: "Элемент уже добавлен",
    height_than: "Высота не должна превышать",
    width_than: "Ширина не должна превышать",
    cannot_add_shape:
      "Нельзя добавить фигуру, если холст полностью заполнен изображением",
    cannot_add_text:
      "Нельзя добавить текст, если холст полностью заполнен изображением",
    already_added: "Уже добавлено",

    cannot_add_image:
      "Нельзя добавить изображение, если холст полностью заполнен другим изображением",
    image_equal:
      "Изображение занимает весь холст, но на нем уже есть другие объекты",
    adjusted_exceeds: "Измененная ширина или высота превышают размер холста",
    canvas_is_empty: "Холст пуст, добавьте текст или изображение",
    provide_image: "Загрузите изображение для шаблона",
    text_price: "Текстовый блок",
    dimensions_height: "Высота не должна превышать размер холста",
    dimensions_width: "Ширина не должна превышать размер холста",
  },

  tips_openAPI: {
    name: "Введите название",
    company_code: "Введите код компании",
    company_name: "Введите название компании",
    email: "Введите электронную почту",
    email_exist: "Этот адрес почты уже используется",
  },

  tips_picture: {
    id: "Введите ID изображения",
    name: "Введите название изображения",
    image_resolution: "Разрешение изображения должно быть менее 400×300 пикселей",
    file_size: "Размер файла не может превышать 2 МБ",
    upload_type: "Допустимы только форматы png, jpeg, jpg",
    character_50: "Название изображения не более 50 символов",
    character_100: "ID изображения не более 100 символов",
    character_name: "Имя не может превышать 100 символов",
    pictureId_exist: "Такой ID изображения уже существует",
    upload_image: "Загрузите изображение",
    image_size: "Размер изображения менее 2 МБ",
    support_size: "Поддерживаются форматы jpeg, jpg, png",
    resolution_size: "Разрешение менее 400×300",
    success: "Изображение успешно добавлено",
    updated: "Данные изображения успешно обновлены",
    deleted: "Изображение успешно удалено",
  },

  tips_dashboard: {
    than_start_date: "Конечная дата должна быть позже начальной даты",
    than_from_date: "Конечная дата периода должна быть позже начальной",
    period_date: "Выберите конечную дату периода",
    period_from_date: "Выберите начальную дату периода",
  },

  tips_authorization: {
    name: "Введите название уровня прав доступа",
    requires_name: "Название обязательно",
    requires_permission: "Требуется разрешение",
    role_client_user: "Роль привязана к пользователю клиента",
    deleted: "Уровень прав успешно удален",
    created: "Уровень прав успешно создан",
    updated: "Уровень прав успешно обновлен",
  },

  tips_product: {
    cannot_deleted: "Этикетка привязана к товару, удаление невозможно",
    last_deleted: "Последнюю этикетку удалить нельзя",
    deleted_product: "Товарная этикетка успешно удалена",
    added_product: "Товарная этикетка успешно добавлена",
    field_empty: "Поле пустое",

    product_name: "Введите название товара",
    product_sku: "Введите артикул товара",
    category_level_1: "Введите категорию первого уровня",
    category_level_2: "Введите категорию второго уровня",
    category_level_3: "Введите категорию третьего уровня",
    quantity: "Введите количество",
    barcode: "Введите штрихкод",
    product_price: "Введите цену товара",
    discount_price: "Введите цену со скидкой",
    brand_name: "Введите название бренда",
    origin_of_product: "Введите страну происхождения товара",
    manufacture: "Введите производителя",
    qr_code: "Введите QR-код",

    choose_excel_file: "Выберите файл Excel для загрузки товаров",
    note_excel_format: "Примечание: поддерживаются только форматы xls, xlsx",
    download_excel_format: "Скачать шаблон Excel",
    add_product_excel: "Загрузить товары из Excel",
    upload_picture: "Нажмите для загрузки изображения",
    country_name: "Введите название страны",

    name_character_limit: "Название менее 51 символа",
    file_size_limit: "Размер файла не более 3 МБ",
    upload_image_format: "Допустимы только png, jpeg, jpg",
    quantity_character_limit: "Количество не более 6 символов",
    category_1_character_limit: "Категория 1 менее 51 символа",
    category_2_character_limit: "Категория 2 менее 51 символа",
    category_3_character_limit: "Категория 3 менее 51 символа",
    manufacturer_character_limit:
      "Название производителя менее 51 символа",
    origin_character_limit:
      "Страна происхождения менее 51 символа",
    name_required: "Название обязательно",
    product_exists: "Товар с таким названием уже существует",
    name_character_limit_50: "Название менее 50 символов",
    name_special_characters: "Название не должно содержать специальных символов",
    drag_and_drop_file: "Перетащите файл сюда или выберите файл",
    upload_file_format: "Загрузить png, jpg",

    product_deleted_success: "Товар успешно удален",
    product_created_success: "Товар успешно создан",
    accept_excel_format: "Поддерживаются только файлы Excel",
    product_updated_success: "Данные товара успешно обновлены",
    product_change_confirmation:
      "Изменение данных товара автоматически обновит привязанные ценники и события изменения цен.<br>Вы уверены, что хотите сохранить изменения?",
    product_delete_confirmation:
      "Удаление товара автоматически удаляет привязанные события изменения цен и журналы синхронизации",
    sure_change_product:
      "Изменение данных товара автоматически обновит привязанные ценники и события изменения цен.<br>Вы уверены, что хотите сохранить изменения?",
    image_format_incorrect: "Неверный формат изображения",
  },

  tips_outlet: {
    outlet_name: "Введите название торговой точки",
    outlet_given_name: "Точка с таким названием уже существует",
    outlet_given_code: "Точка с таким кодом уже существует",
    name_length: "Название менее 50 символов",
    code_length: "Код менее 30 символов",
    code_alphanumeric: "Код должен содержать только буквы и цифры",
    code_exceed: "Код не может превышать 30 символов",
    outlet_delete_restricted: "Точка привязана к устройствам, удаление невозможно",
    outlet_deleted: "Торговая точка успешно удалена",
    outlet_created: "Торговая точка успешно создана",
    outlet_updated: "Данные точки успешно обновлены",
    select_outlet: "Выберите торговую точку",
  },

  tips_user: {
    outlet_in_charge: "Ответственный за торговую точку",
    permission_group_name: "Название группы прав доступа",
    date_of_joining: "Дата регистрации",
    first_name: "Введите имя",
    last_name: "Введите фамилию",
    person_id: "Введите ID пользователя",
    enter_email: "Введите электронную почту",
    select_date: "ДД-ММ-ГГГГ (выберите дату)",
    first_name_limit: "Имя не более 100 символов",
    allowed_file_types: "Допустимы только форматы jpeg, jpg, png",
    max_file_size: "Максимальный размер файла 3 МБ",
    user_exists: "Пользователь уже существует",
    phone_required: "Телефон обязателен",
    outlet_required: "Торговая точка обязательна",
    role_required: "Роль обязательна",
    activation_mail_confirmation: "Вы уверены, что хотите отправить письмо активации?",
    activation_mail_sent: "Письмо активации успешно отправлено",
    cannot_delete_default_user: "Стандартного пользователя удалить нельзя",
    person_deleted: "Пользователь успешно удален",
    person_created: "Пользователь успешно создан",
    person_updated: "Данные пользователя успешно обновлены",
  },

  tips_gateway: {
    deviceNetworkConfigSteps: "Шаги настройки сети устройства",
    step1PowerUp: "Шаг 1: Подключите питание и включите устройство",
    step1Description:
      "Если устройство видит сеть, оно подключится автоматически и начнет работу",
    step2ConfigureNetwork: "Шаг 2: Настройте сеть",
    step2Description:
      "Сеть можно настроить по Bluetooth, либо через сенсорный экран в прошивке устройства",
    step3RestoreFactorySettings: "Шаг 3: Сброс до заводских настроек",
    step3Description:
      "Если на устройстве нет настроек сети, выполните сброс до заводских параметров",
    readInstructions: "Я ознакомился с инструкцией",

    manualRegisterDevice: "Ручная регистрация устройства",
    powerUpAndSetNetwork: "Подключите питание и настройте сеть устройства",
    step1EthernetConnection:
      "1. Подключите сетевой кабель, если устройство поддерживает Ethernet",
    step2CommunicationSetting:
      "2. Перейдите в меню настроек Ethernet/WiFi, после успешной настройки на экране ожидания появится QR-код",
    step3FindSerialNumber:
      "3. Серийный номер указан на коробке или задней панели устройства",
    step4FillSerialNumber: "4. Введите серийный номер в систему",

    specifyDeviceForClient:
      "Привяжите устройство к розничному клиенту и торговой точке",
    syncOutletTimeZone:
      "Устройство будет использовать часовой пояс торговой точки",
    device_does_not: "Устройство не найдено",
    selectFile: "Выберите файл",
    versionStartWithV: "Версия должна начинаться с буквы V",
    enterUpgradePackageVersion:
      "Введите версию пакета обновления, начинающуюся с V",
    uploadSuccessful: "Загрузка выполнена успешно",
    uploadAndUpgrade: "Загрузить пакет обновления и выполнить обновление",
    uploadFile: "Загрузить файл",
    unsupportedType: "Данный формат файла не поддерживается",
    fileSizeLimit:
      "Размер файла превышен: {{fileSize}} МБ. Загружайте файлы размером до 100 МБ",
    dragOrBrowse: "Перетащите файл или выберите через проводник",
    onlyApkFormat: "Допустимы только файлы формата apk",

    searchByDeviceSn: "Искать по серийному номеру устройства",
    selectYourZone: "Выберите зону",
    bindZone: "Привязать зону",
    enterDeviceSerialNumber: "Введите серийный номер устройства",
    readInstructionsToAddDevice:
      "Ознакомьтесь с инструкцией и отметьте галочку для добавления устройства",

    deviceUnbindSuccess: "Устройство успешно отвязано",
    deviceBindSuccess: "Устройство успешно привязано",
    upload_excel_file: "Загрузите файл Excel",
    device_has_been_bound: "Устройство уже привязано",
    adv_ground: "Рекламная группа",
  },

  tips_screens: {
    choose_Product_display: "Выберите товар для отображения на ценнике",
    choose_Template_display: "Выберите шаблон для отображения на ценнике",
    selected_screen: "Выбранный ценник",
    search_by_screenId: "Искать по ID ценника",
    enter_screen_name: "Введите название ценника",
    enter_position_no: "Введите номер позиции",
    enter_gateway_sn: "Введите серийный номер шлюза",
    template_not_empty: "Шаблон не может быть пустым",
    product_not_empty: "Товар не может быть пустым",
    company_id_required: "ID компании обязателен",
    select_one_screen: "Выберите ценник",
    confirm_unbind_device: "Вы уверены, что хотите отвязать выбранное устройство?",
    deviceUn_bind_success: "Устройство успешно отвязано",
    screens_sync_success: "Синхронизация ценников выполнена успешно",
    select_promotion_StartTime: "Выберите время начала акции",
    select_or_screen: "Выберите один или несколько ценников",
    batch_update_screen_success: "Массовое редактирование ценников выполнено успешно",
  },

  tips_events: {
    deleted: "Событие изменения цен успешно удалено",
    created: "Событие изменения цен успешно создан",
    updated: "Событие изменения цен успешно обновлено",
  },

  tips_approval: {
    change_status: "Вы уверены, что хотите изменить статус?",
    updated: "Запись успешно обновлена",
    not_empty: "Выберите уникальное значение, поле не может быть пустым",
    deleted: "Процесс согласования успешно удален",
    added: "Процесс согласования успешно добавлен",
    information:
      "Если любой из согласующих утвердит событие, данные синхронизируются на ценники",
  },

  tips_mobile: {
    mobile_api_management: "Управление мобильными приложениями",
    app_name: "Название приложения",
    app_version_type: "Тип версии приложения",
    app_mobile_version: "Версия мобильного приложения",
    is_there_any_update: "Есть ли обновление",
    is_it_a_force_update: "Принудительное обновление",
    version_name: "Название версии",
    version_number: "Номер версии",
    type: "Тип",
    update_content: "Описание обновления",
    update_address: "Ссылка на обновление",
    actions: "Действия",
    app_version_type: "Тип версии приложения",
    app_name_max_length: "Название приложения не более 50 символов",
    app_name_required: "Название приложения обязательно",
    type_required: "Тип обязателен",
    version_number_required: "Номер версии обязателен",
    invalid_version_number: "Неверный номер версии",
    have_update_required: "Поле «есть обновление» обязательно",
    force_update_required: "Поле «принудительное обновление» обязательно",
    update_content_required: "Описание обновления обязательно",
    update_address_required: "Ссылка на обновление обязательна",
    successfully_created_app: "Мобильное приложение успешно создано",
    insufficient_privileges: "Недостаточно прав доступа",
    add_new_app: "Добавить новое приложение",
    app_name_label: "Название приложения",
    app_name_placeholder: "Введите название приложения",
    type_label: "Тип",
    type_placeholder: "Выберите тип",
    version_number_label: "Номер версии",
    version_number_placeholder: "Введите номер версии",
    have_update_label: "Есть обновление",
    have_update_placeholder: "Выберите вариант",
    force_update_label: "Принудительное обновление",
    force_update_placeholder: "Выберите вариант",
    update_content_label: "Описание обновления",
    update_content_placeholder: "Введите описание обновления",
    update_address_label: "Ссылка на обновление",
    update_address_placeholder: "Введите ссылку на обновление",

    edit_new_app: "Редактировать приложение",
    edit_name_label: "Название приложения",
    edit_name_placeholder: "Введите название приложения",
    type_label: "Тип",
    type_placeholder: "Выберите тип",
    version_number_label: "Номер версии",
    version_number_placeholder: "Введите номер версии",
    have_update_label: "Есть обновление",
    have_update_placeholder: "Выберите вариант",
    force_update_label: "Принудительное обновление",
    force_update_placeholder: "Выберите вариант",
    update_content_label: "Описание обновления",
    update_content_placeholder: "Введите описание обновления",
    update_address_label: "Ссылка на обновление",
    update_address_placeholder: "Введите ссылку на обновление",
    save: "сохранить",
    mobile_app_updated_successFully: "Данные приложения успешно обновлены",
    app_name_is_required: "Название приложения обязательно",
    app_name_can_not_be_greater_then_50_character:
      "Название приложения не более 50 символов",
    type_is_required: "Тип обязателен",
    version_number_is_required: "Номер версии обязателен",
    Invalid_version_number: "Неверный номер версии",
    Have_update_is_required: "Поле «есть обновление» обязательно",
    Force_Update_is_required: "Поле «принудительное обновление» обязательно",
    Update_content_is_required: "Описание обновления обязательно",
    Update_address_is_required: "Ссылка на обновление обязательна",
    Android: "ANDROID",
    Ios: "IOS",
    Force_Update_required: "Требуется",
    Force_Update_not_required: "Не требуется",
    Any_Update_Yes: "ДА",
    Any_Update_No: "НЕТ",
    Mobile_version_deleted_successfully: "Версия мобильного приложения успешно удалена",
    Delete_conformation: "Подтверждение удаления",
    Enter_the_name: "Введите название",
  },
};
